// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:18
import { GeoSectorComplement_abstract } from './../abstract/SagaSchema/GeoSectorComplement_abstract';
export class GeoSectorComplement extends GeoSectorComplement_abstract {}
